module.exports = __webpack_public_path__ + "img/2m.09875141.jpg";